import { isOwnedStation } from '@app/core/stations/helpers';
import { StationAccessFilterType } from '../components/options';
import { Station } from '@app/core/types/stations';

/** Maps a station to the status screen access filter bucket (owned or shared). */
export function getStationAccessFilterType(station: Station): StationAccessFilterType {
  if (isOwnedStation(station)) {
    return StationAccessFilterType.OWNED;
  }

  return StationAccessFilterType.SHARED;
}
